import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center p-5 bg-primary30" }
const _hoisted_2 = { class: "mb-12" }
const _hoisted_3 = { class: "w-full flex justify-center" }
const _hoisted_4 = { class: "w-full max-w-md bg-white rounded shadow-lg p-10 flex flex-col items-center text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "font-inter font-bold text-lg leading-7 text-[#333333] mb-4" }, " O cadastro de médicos é feito pelo aplicativo ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-inter text-base text-gray-600 mb-8 max-w-xs sm:max-w-sm" }, " Baixe o app Minha Escala, crie sua conta e gerencie seus plantões direto do celular. ", -1)

import { ref, onMounted } from 'vue'
import { useToast } from 'vue-toastification'
import Logo from '@/components/designSystem/Logo/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import AppStoreBadges from '@/components/designSystem/AppStoreBadges/index.vue'
import { isMobileUserAgent, openAppStore } from '@/utils/appStoreLinks'
import PATHS from '@/router/paths'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const toast = useToast()
const isMobileDevice = ref(false)

onMounted(() => {
  isMobileDevice.value = isMobileUserAgent()
})

const openStore = () => {
  openAppStore(() =>
    toast.info('Abra a loja de aplicativos do seu celular e procure por "Minha Escala"')
  )
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo, {
        width: "160px",
        logo: "full_text_white"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(AppStoreBadges, { class: "mb-4 justify-center" }),
        (isMobileDevice.value)
          ? (_openBlock(), _createBlock(FilledButton, {
              key: 0,
              text: "Abrir loja de aplicativos",
              width: "100%",
              class: "mb-4",
              onClick: openStore,
              "data-testid": "signup-doctor-open-app-button"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: _unref(PATHS).SIGNIN,
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(GhostButton, {
              text: "Voltar para o login",
              width: "100%",
              "data-testid": "signup-doctor-back-login-button"
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})